import { useRedux } from "hooks";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import Loader from "./Loader";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync } from "../api/chats";
import { findMemberToGroup } from "../redux/profile2/p2_reducer";
import { addUserToGroup } from "../redux/actions";
import { Exception } from "sass";
import { Utils } from "helpers/utils";
import FormInput from "./FormInput";
import UserAvatar from "./UserAvatar";
import { debounce, last, set } from "lodash";
import classnames from "classnames";
import { FormCheck } from "react-bootstrap";
import { UserTypes } from "api";
import TextBox from "./TextBox";
import LoadingIconWithText from "./LoadingIconWithText";
import { APIClient } from "api/apiCore";
import * as urls from "api/urls";




interface AddMemberToGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  groupId: number;
  groupType: UserTypes;
}

const AddMemberToGroupModal = ({
  isOpen,
  onClose,
  groupId,
  groupType,
}: AddMemberToGroupModalProps) => {

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Profile2,
    (state) => ({
      // groupInviteCode: state.groupInviteCode,
      // groupInviteOn: state.groupInviteOn,
      profile2: state,

      findMember: state.findMember,
      findMemberCus: state.findMemberCus,
      findMemberOn: state.findMemberOn,
      findMemberFilter: state.findMemberFilter,
      findMemberCusFilter: state.findMemberCusFilter,
      findMemberFilterUserType: state.findMemberFilterUserType ?? UserTypes.Employee,
    })
  );
  const { /*groupInviteCode, groupInviteOn,*/ profile2, findMember, findMemberCus, findMemberOn, findMemberFilter, findMemberCusFilter, findMemberFilterUserType } = useAppSelector(storeData);
  // console.log('profile2:', profile2);
  const [isGenCode, setIsGenCode] = useState<boolean>(false);
  const [errMessage, _a1] = useState<string>("");
  const [errClass, _a2] = useState<string>("danger");
  const [groupInviteCode, setGroupInviteCode] = useState('');
  const [showNewCustDiv, setShowNewCustDiv] = useState<boolean>(false);
  // console.log('profile2:', profile2);


  useEffect(() => {
    // console.log('profile2-2:', profile2);
    const fetch = async () => {
      await getGroupInviteCodeAsync(profile2.activeGroupId)
        .then(response => {
          setGroupInviteCode(response);
        })
        .catch(err => console.error(err));
    }
    fetch();
  }, []);


  const onModalClose = () => {
    onClose();
  }

  // const debounceFindMemberToGroup = debounce((groupId, filter, filterUserType) => {
  //   console.log('debounceFindMemberToGroup:', {groupId, filter, filterUserType});
  //   dispatch(findMemberToGroup(groupId, filter, filterUserType));
  // }, 1800); // Adjust the debounce time as necessary      

  const debounceFindMemberToGroup = useCallback(
    debounce((groupId, filter, filterUserType) => {
      //console.log("debounceFindMemberToGroup:", { groupId, filter, filterUserType });
      dispatch(findMemberToGroup(groupId, filter, filterUserType));
    }, 800),
    [] // Dependencies are empty so it's only created once
  );

  const onFilter = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    debounceFindMemberToGroup(groupId, newValue, lastUserType);
    if (lastUserType == UserTypes.Customer) {
      setLastFilterCus(newValue);
    } else if (lastUserType == UserTypes.Supplier) {
      setLastFilterSup(newValue);
    } else {
      setLastFilterEmp(newValue);
    }
    // setLastFilter(newValue);
    setShowNewCustDiv(false);
    // dispatch(findMemberToGroup(newValue));
  }

  const [lastFilterEmp, setLastFilterEmp] = useState("");
  const [lastFilterCus, setLastFilterCus] = useState("");
  const [lastFilterSup, setLastFilterSup] = useState("");
  const [lastUserType, setLastUserType] = useState(UserTypes.Employee);

  //  const txtFilter = useRef<any>(null);
  useEffect(() => {
    // if (txtFilter && txtFilter.current){
    //     txtFilter.current.value = findMemberFilter;
    // }
    setLastFilterEmp(findMemberFilter);
    setLastFilterCus(findMemberCusFilter);
    setLastFilterSup(findMemberCusFilter);
    setLastUserType(findMemberFilterUserType);


    //debounceFindMemberToGroup(groupId, findMemberFilter, findMemberFilterUserType); 20250306 เปลี่ยนเป็นไม่ต้อง search ทุกครั้งที่เปลี่ยนกลุ่ม เพิ่ม performance
    // console.log(findMemberFilter);
  }, [groupId]);

  useEffect(() => {
    // console.log(`AddMemberToGroupModal GroupID = ${groupId}, GroupType = ${groupType}`);
  }, [groupId, groupType]);

  const onRadioUserTypeChanged = async (userType: UserTypes) => {
    setLastUserType(userType);
  }

  useEffect(() => {
    // debounceFindMemberToGroup(groupId, findMemberFilter, lastUserType);
    //dispatch(findMemberToGroup(groupId, findMemberFilter, lastUserType)); -> 20250401 no need to auto refresh because separate result between emp & cus for better performance
  }, [lastUserType]);

  useEffect(() => {
    // debounceFindMemberToGroup(groupId, findMemberFilter, lastUserType);
    dispatch(findMemberToGroup(groupId, findMemberFilter, lastUserType));
  }, []);

  const [memberListToShow, setMemberListToShow] = useState(lastUserType == UserTypes.Employee ? findMember : findMemberCus);
  const [lastFilter, setLastFilter] = useState(lastUserType == UserTypes.Employee ? lastFilterEmp : lastFilterCus);
  useEffect(() => {
    setMemberListToShow(lastUserType == UserTypes.Employee ? findMember : findMemberCus);
  }, [lastUserType, findMember, findMemberCus]);

  useEffect(() => {
    setLastFilter(lastUserType == UserTypes.Employee ? lastFilterEmp : lastFilterCus);
  }, [lastUserType, lastFilterEmp, lastFilterCus]);

  // useEffect(()=>{
  //     console.log('txtFilter:', txtFilter);
  // },[]);

  const onAddMember = async (userId: number, isAdd: boolean) => {
    dispatch(addUserToGroup(groupId, userId, isAdd));
  }

  const allowChooseCustomer = true;//false;

  const [newCustSaving, setNewCustSaving] = useState<boolean>(false);
  const [newCustName, setNewCustName] = useState<string>("");
  const [newCustSurname, setNewCustSurname] = useState<string>("");
  const [newCustNickName, setNewCustNickName] = useState<string>("");
  const [newCustMobile, setNewCustMobile] = useState<string>("");

  const checkNewCustData = () => {
    if (!newCustName) {
      alert('กรุณาระบุชื่อต้น');
      return false;
    }
    if (!newCustSurname) {
      alert('กรุณาระบุนามสกุล');
      return false;
    }
    if (!newCustMobile) {
      alert('กรุณาระบุเบอร์โทร');
      return false;
    }
    return true;
  }

  const onCreateNewCusClick = () => {
    try {
      setNewCustSaving(true);
      if (!checkNewCustData()) {
        setNewCustSaving(false);
        return;
      }

      const parm = {
        firstName: newCustName,
        lastName: newCustSurname,
        nickName: newCustNickName,
        mobileNo: newCustMobile,
        groupType: groupType
      }
      const api = new APIClient
      api.fnPostForm(urls.CREATE_NEW_CUSTOMER, parm)
        .then((response) => {
          console.log('response:', response);
          if (response.err) {
            alert(response.err)
          } else {
            setLastFilterCus(response.mobileNo);
            setLastFilterSup(response.mobileNo);
            dispatch(findMemberToGroup(groupId, response.mobileNo, groupType == UserTypes.GroupSupplier ? UserTypes.Supplier : UserTypes.Customer));
            setShowNewCustDiv(false);
          }
          setNewCustSaving(false);
        })
        .catch((error) => {
          alert((error as any).message);
          setNewCustSaving(false);
        });

    } catch (e) {
      alert((e as any).message);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={onModalClose} tabIndex={-1} centered scrollable size="lg" >
      <ModalHeader className="bg-primary" toggle={onModalClose}>
        <div className="modal-title-custom text-white font-size-16 ">
          เลือกสมาชิก เพื่อเพิ่มเข้ากลุ่ม
          &nbsp;{findMemberOn && (<Spinner size={"sm"} />)}
        </div>
      </ModalHeader>
      <ModalBody className="p-4 ">
        <Form>
          {errMessage && (
            <div className="mb-3">
              <div className={"alert alert-" + errClass + " text-center"}>{errMessage}</div>
            </div>
          )}
          <div className="mb-3">
            {/* <span onClick={fnTest}>content</span> */}
            {/* <FormInput
                            type="text"
                            name="filter"
                            errors={"hello"}
                            placeholder="ชื่อ/ชื่อเล่น/เบอร์โทร"
                            className="form-control mb-2"
                            // value={lastFilter}
                            onInput={onFilter}
                        /> */}
            {allowChooseCustomer && (
              <div className="row">
                <div className="col">
                  <input type="radio" name="rdUserType" id="rdEmp" value={UserTypes.Employee} checked={lastUserType == UserTypes.Employee} onChange={(e) => onRadioUserTypeChanged(UserTypes.Employee)} ></input>
                  <label htmlFor="rdEmp">&nbsp;เลือก พนักงาน </label>

                </div>
                {groupType == UserTypes.Group && (
                  <div className="col">
                    <input type="radio" name="rdUserType" id="rdCus" value={UserTypes.Customer} checked={lastUserType == UserTypes.Customer} onChange={(e) => onRadioUserTypeChanged(UserTypes.Customer)}></input>
                    <label htmlFor="rdCus">&nbsp;เลือก ลูกค้า</label>
                  </div>
                )}
                {groupType == UserTypes.GroupSupplier && (
                  <div className="col">
                    <input type="radio" name="rdUserType" id="rdSup" value={UserTypes.Supplier} checked={lastUserType == UserTypes.Supplier} onChange={(e) => onRadioUserTypeChanged(UserTypes.Supplier)}></input>
                    <label htmlFor="rdSup">&nbsp;เลือก Supplier</label>
                  </div>
                )}
              </div>
            )}
            {lastUserType == UserTypes.Customer && (
              <div className="row">
                <div className="col text-center">
                  <div className="alert alert-danger" style={{ paddingTop: "1px", paddingBottom: "1px" }}>โปรดใช้ความระมัดระวังในการ<br />เลือกลูกค้าเข้าห้องแชท ให้ถูกบริษัท</div>
                </div>
              </div>
            )}
            {lastUserType == UserTypes.Supplier && (
              <div className="row">
                <div className="col text-center">
                  <div className="alert alert-danger" style={{ paddingTop: "1px", paddingBottom: "1px" }}>โปรดใช้ความระมัดระวังในการ<br />เลือก Supplier เข้าห้องแชท ให้ถูกบริษัท</div>
                </div>
              </div>
            )}


            {lastUserType == UserTypes.Employee && (
              <input
                // ref={txtFilter}
                type="text"
                placeholder={"ชื่อ/ชื่อเล่น/เบอร์โทร"}
                className="form-control mb-2"
                onChange={onFilter}
                value={lastFilterEmp}
              ></input>
            )}
            {lastUserType == UserTypes.Customer && (
              <input
                // ref={txtFilter}
                type="text"
                placeholder={"เบอร์โทรลูกค้า 10 หลัก"}
                className="form-control mb-2"
                onChange={onFilter}
                value={lastFilterCus}
              ></input>
            )}
            {lastUserType == UserTypes.Supplier && (
              <input
                // ref={txtFilter}
                type="text"
                placeholder={"เบอร์โทร Supplier 10 หลัก"}
                className="form-control mb-2"
                onChange={onFilter}
                value={lastFilterSup}
              ></input>
            )}

            <div className="add-member-to-group-modal-body" style={{ overflow: "auto" }}>
              {(memberListToShow || []).length <= 0 && (<div className="text-center">---ไม่พบข้อมูล---</div>)}
              <ul style={{ paddingLeft: "0px" }}>
                {(memberListToShow || []).map((item: any, key: number) => {

                  return (
                    <div key={key} className="d-flex align-items-center hover line-divider-bottom" >
                      <UserAvatar
                        profileImage={item.profileImage}
                        bgColor={item.bgColor}
                        foreColor={item.foreColor}
                        abbrName={item.abbrName}
                      />

                      <div className="flex-grow-1 overflow-hidden ">
                        <p className="text-truncate mb-0 " >
                          <div className="">{item.fullName}</div>
                          <div className="pb-1">
                            <span style={{ fontSize: "0.9rem", color: "gray" }}>
                              <span className={"badge fz-08 fw-normal badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserTypeBg(item.userType)}>
                                {Utils.GetUserTypeText(item.userType)}
                              </span>
                              &nbsp;
                              <span className={"badge fz-08 fw-normal badge-soft-primary rounded p-1 ml-1 bg-secondary"}>
                                {item.userType == UserTypes.Employee ? item.positionName : item.companyName}
                              </span>
                            </span>
                          </div>
                        </p>

                      </div>
                      <div className="ms-auto">
                        <span className="mdi mdi-phone"></span>&nbsp;{item.authMobileNo}
                      </div>
                      <div className="ms-auto">&nbsp;
                        <span
                          className={classnames("mdi hand", {
                            "mdi-minus-circle": item.isAlreadyMember,
                            "text-danger": item.isAlreadyMember,
                            "mdi-plus-circle": !item.isAlreadyMember,
                            "text-success": !item.isAlreadyMember
                          })}
                          onClick={() => onAddMember(item.userId, !item.isAlreadyMember)} style={{ fontSize: "2rem" }}></span>&nbsp;
                      </div>
                    </div>
                  )
                })}
              </ul>
            </div>

            {/* {(lastUserType == UserTypes.Customer && showNewCustDiv) && ( */}
            {((lastUserType == UserTypes.Customer || lastUserType == UserTypes.Supplier) && showNewCustDiv) && (
              <div className="div-add-new-cus">
                <div className="row">
                  <div className="col">
                    <h4><div className="alert alert-primary text-center">เพิ่มข้อมูล {lastUserType == UserTypes.Customer ? "ลูกค้า" : "Supplier"} ใหม่</div></h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    ชื่อต้น
                    <TextBox type="text" className="form-control" placeholder="ชื่อต้น" onEnter13={onCreateNewCusClick} onChange={(e) => setNewCustName(e.target.value)} />
                  </div>
                  <div className="col">
                    นามสกุล
                    <TextBox type="text" className="form-control" placeholder="นามสกุล" onEnter13={onCreateNewCusClick} onChange={(e) => setNewCustSurname(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    ชื่อเล่น
                    <TextBox type="text" className="form-control" placeholder="ชื่อเล่น" onEnter13={onCreateNewCusClick} onChange={(e) => setNewCustNickName(e.target.value)} />
                  </div>
                  <div className="col">
                    เบอร์โทร
                    <TextBox type="tel" className="form-control" placeholder="เบอร์โทร" onEnter13={onCreateNewCusClick} onChange={(e) => setNewCustMobile(e.target.value)} />
                  </div>
                </div>
                <div className="row py-2">
                  <div className="col text-end">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowNewCustDiv(false)}>ยกเลิก</button>&nbsp;
                    <button type="button" className="btn btn-primary" onClick={() => { onCreateNewCusClick(); return false; }}>{newCustSaving && (<Spinner color="info" size="sm" />)}สร้าง</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Form>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">

        {(lastUserType == UserTypes.Customer && allowChooseCustomer) ? (
          <Button type="button" color="warning" className="btn" onClick={() => setShowNewCustDiv((prev) => !prev && lastUserType == UserTypes.Customer)}>เพิ่มข้อมูลลูกค้าใหม่</Button>
        ) : <>&nbsp;</>}

        {(lastUserType == UserTypes.Supplier && allowChooseCustomer) ? (
          <Button type="button" color="warning" className="btn" onClick={() => setShowNewCustDiv((prev) => !prev && lastUserType == UserTypes.Supplier)}>เพิ่มข้อมูล Supplier ใหม่</Button>
        ) : <>&nbsp;</>}

        <Button type="button" color="secondary" className="btn" onClick={onModalClose} >
          ปิด
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddMemberToGroupModal;
